import app from '../app';
import { selectIsByHomeowner, selectOfferId } from '../../../../shared/selectors/offer';
import { openModal } from '../../../../shared/utils/modals';

export const HOMEOWNER_AND_NEED_IDENTIFICATION = 'HomeownerAndNeedIdentification';

const windowModeTypes = [
  'IdentificationAndNeedCommercial',
  'NeedCommercialWithoutIdentification',
  'OnCommercialDepositRequiredWithoutIdentification',
  'OnCommercialDepositRequiredWithIdentification',
  'NeedCommercialForCurrentCategory',
  HOMEOWNER_AND_NEED_IDENTIFICATION,
  'NeedIdentificationOnly',
];

app.service('pubAvailService', [
  'apiService',
  'geoService',
  'popupService',
  'userIdentificationService',
  'telemetryService',
  'publishTermsService',
  'store',
  '$rootScope',
  function (
    apiService,
    geoService,
    popupService,
    userIdentificationService,
    telemetryService,
    publishTermsService,
    store,
    $rootScope,
  ) {
    let pubAvailModalInstance;

    this.isNeedIdentification = false;

    /**
     * Проверяем, возможна ли публикация в данной категории, по указанному адресу. Вызывается при смене категории или адреса.
     * Публикацию запрещаем только в случае успешного ответа и popUpActionType === 'Show'. Во всех других случаях, включая ошибки сервера,
     * считаем, что публикация возможна.
     * От этого метода зависит видимость условий размещения и кнопки публикации.
     * @param category
     * @param locationPath
     * @return {*}
     */
    const checkPubAvailRequest = (category, locationPath) => {
      this.isAvailable = undefined;
      this.showPopup = false;
      this.isLoading = true;

      const state = store.getState();
      const isByHomeowner = selectIsByHomeowner(state);
      const offerId = selectOfferId(state);

      telemetryService.mark('addform.publication-availability-start');

      const params = {
        category,
        locationPath: locationPath.join(','),
        latitude: geoService.getCoordinates().lat,
        longitude: geoService.getCoordinates().lng,
        isByHomeowner,
      };

      if (offerId) {
        params.realtyObjectId = offerId;
      }

      return apiService
        .getPubAvail(params)
        .then(data => {
          telemetryService.mark('addform.publication-availability-end');
          telemetryService.sendMeasuredTimer(
            'addform.publication-availability-request',
            'addform.publication-availability-start',
            'addform.publication-availability-end',
          );

          if (!data) {
            throw new Error('Publication availability service: no data in API response');
          }

          if (data.popUpActionType === 'Show' && !windowModeTypes.includes(data.windowModeType)) {
            throw new Error(`Publication availability service: unknown windowModeType (${data.windowModeType})`);
          }

          this.showPopup = data.popUpActionType === 'Show';
          this.pubAvailData = data;
        })
        .finally(() => {
          this.isAvailable = !this.showPopup;
          this.isLoading = false;
          if (window.location.search.includes('autopublish')) {
            $rootScope.$emit('scrollTo', 'ad-placing-terms');
            $rootScope.$broadcast('simulateSubmitClick');
          }
        });
    };

    // publication availability
    this.checkPubAvail = (category, locationPath) => {
      checkPubAvailRequest(category, locationPath).then(() => {
        const state = store.getState();
        const isByHomeowner = selectIsByHomeowner(state);

        this.isNeedIdentification =
          this.pubAvailData &&
          this.pubAvailData.windowModeType === HOMEOWNER_AND_NEED_IDENTIFICATION &&
          // на новом ФВУ временно оставляем старый флоу идентификации
          !publishTermsService.isNewPublishTermsEnabled();

        userIdentificationService.setIsUserNeedIdentification(this.isNeedIdentification);

        // Если нужна идентификация через sumsub не нужно показывать ни попап, ни информационный блок
        // если включен флаг identificationInstruction.onlyDocumentsAllowed то идем новым флоу
        // и показываем попап
        const isOnlyDocuments = this.pubAvailData?.identificationInstruction?.onlyDocumentsAllowed;

        // если есть кука идентификации, не новый флоу или новый флоу и соб
        if (this.isNeedIdentification && (!isOnlyDocuments || isByHomeowner)) {
          this.showPopup = false;
          this.isAvailable = false;
          this.pubAvailPopupShown = true;

          return;
        }

        if (!this.showPopup) {
          // прячем попап если он уже показан
          // такое возможно, если пользователь изменил адрес до того как сервис вернул ответ по старому адресу
          // todo: использовать таймаут-промис в pubAvailService.checkPubAvail вместо этого
          if (popupService.isOpen('pubAvail') && pubAvailModalInstance) {
            pubAvailModalInstance.dismiss();
          }
        } else if (!this.pubAvailPopupShown) {
          this.pubAvailPopupShown = true; // show only once
          pubAvailModalInstance = openModal('pubAvail');
        }
      });
    };
  },
]);
